import { DateRangePicker } from '@/view/components/DateRangePicker'
import { BasicFilter } from '@/view/components/BasicFilter'
import { Button } from '@/view/components/ui/button'
import { useSellerStatementFilterController } from './useSellerStatementFilterController'

type StatementFilterParams = {
  startDate: string
  endDate?: string
}

type SellerStatementFilterProps = {
  onFilter: (params: StatementFilterParams) => void
  onClear: () => void
}

export const SellerStatementFilter = ({
  onFilter,
  onClear,
}: SellerStatementFilterProps) => {
  const {
    selectedDate,
    handleDateChange,
    handleClearFilter,
    handleFilterSubmit,
  } = useSellerStatementFilterController({
    onFilter,
    onClear,
  })

  return (
    <div className="flex items-center justify-between">
      <BasicFilter>
        <form onSubmit={handleFilterSubmit}>
          <div className="px-4">
            <h2 className="mb-2 font-medium text-black04">Data</h2>
            <DateRangePicker
              date={selectedDate}
              onDateChange={handleDateChange}
              numberOfMonths={1}
            />
          </div>
          <div className="my-5 w-full border-b-[1px] border-gray01" />
          <div className="flex items-center justify-between p-4">
            <Button
              type="button"
              onClick={handleClearFilter}
              variant="outline"
              className="w-24 rounded-full bg-gray02 text-xs font-bold"
            >
              Limpar
            </Button>
            <Button
              type="submit"
              className="w-20 rounded-full bg-primary text-xs font-bold text-white01"
            >
              Filtrar
            </Button>
          </div>
        </form>
      </BasicFilter>
    </div>
  )
}
